import React, { useEffect } from 'react';

import { loadGlobalDismissStore } from '@zillow/app-upsell-dismiss-store';
import { BrowserSelect } from '@zillow/app-upsell-two-cta';
import { withImpression } from '@zillow/app-upsell-utils';
import { withExperimentation, withHandlers } from '@zillow/home-page-app-upsell';
import { useBotState, useMobileState } from '@zillow/shopper-platform-config';

import { useGlobalStoreState } from '../../contexts/GlobalStoreProvider';

const UpsellComponent = withExperimentation(withImpression(withHandlers(BrowserSelect)));

function AppUpsellBanner() {
    const isMobile = useMobileState();
    const isBot = useBotState();
    const { city, zipcode, abs } = useGlobalStoreState();

    useEffect(() => {
        // Calling this allows the upsell component to keep track of the
        // dismissed state. We don't need to manage it ourselves.
        loadGlobalDismissStore({});
    }, []);

    return (
        <div id="local-app-upsell" className="no-animation">
            {!isBot && isMobile && (
                <UpsellComponent
                    fixed
                    inline
                    pageType="Homepage"
                    geoIpLocation={{
                        city,
                        zipcode,
                    }}
                    abs={abs}
                />
            )}
        </div>
    );
}

export default AppUpsellBanner;
